import React from 'react';
import { Box, List, ListItem, ListItemIcon, ListItemText, ThemeProvider, createTheme } from '@mui/material';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacy';
import PetsIcon from '@mui/icons-material/Pets';
import BuildIcon from '@mui/icons-material/Build';
import StoreIcon from '@mui/icons-material/Store';
import StorefrontIcon from '@mui/icons-material/Storefront';
import LocalConvenienceStoreIcon from '@mui/icons-material/LocalConvenienceStore';
import { useLoaderData, useParams } from 'react-router-dom';

// import { BUSINESSES_LIST } from '../../routes';
// import { withRouter } from "react-router-dom";

function ListItemLink(props) {
  return <ListItem button component="a" {...props} />;
}

const theme = createTheme();

const BusinessTypes = ({ businessTypeIcons }) => {
  const businessTypes = useLoaderData();
  const { department, city, neighborhood } = useParams();
  const url = neighborhood ? `/${department}/${city}/${neighborhood}` : `${department}/${city}`;
  return (
    <div className='container'>
      <ThemeProvider theme={theme}>
    <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
      <nav>
        <List>
          {businessTypes.map((type, index) => (
            <ListItemLink href={`${url}/${type.alias}`}>
              <ListItemIcon>
                {businessTypeIcons[type.alias]}
              </ListItemIcon>
              <ListItemText primary={type.name} />
            </ListItemLink>
          ))}
        </List>
      </nav>
    </Box>
      </ThemeProvider>
    </div>
  );
}

BusinessTypes.defaultProps = {
  businessTypeIcons: {
    'restaurantes': <RestaurantIcon />,
    'droguerias': <LocalPharmacyIcon />,
     'tiendas-y-fruver': <StoreIcon />,
    'mascotas': <PetsIcon />,
    'carnicerias': <StorefrontIcon />,
    'ferreterias': <BuildIcon />,
    'otros': <LocalConvenienceStoreIcon />
  }
};

// export default withRouter(BusinessTypes);
export default BusinessTypes;
